import { useMemo, useCallback } from 'react';
import '../apis/file/apis/file-download-controller-api.mjs';
import '../apis/file/apis/file-info-controller-api.mjs';
import '../apis/file/apis/file-restriction-controller-api.mjs';
import '../apis/file/apis/image-download-controller-api.mjs';
import '../apis/file/apis/temporary-file-upload-controller-api.mjs';
import { FileSourceType } from '../apis/file/models/file-source-type.mjs';
import { useGetFileSourceTypeRestrictionsRemote } from '../apis/file-hooks/useGetFileSourceTypeRestrictionsRemote.mjs';

const A_DAY = 24 * 60 * 60 * 1e3;
const useGetFileSourceTypeRestrictions = (options) => {
  const { data, ...rest } = useGetFileSourceTypeRestrictionsRemote({
    ...options,
    staleTime: A_DAY
  });
  const normalizedData = useMemo(() => data && normalizeResponse(data), [data]);
  const getRestrictionInfo = useCallback(
    (sourceType) => {
      if (!normalizedData) {
        return;
      }
      const {
        fileExtensionWhitelists,
        fileRestrictionTypes,
        fileSourceTypeRestrictions
      } = normalizedData;
      const targetSourceType = fileSourceTypeRestrictions[FileSourceType[sourceType]];
      if (targetSourceType === void 0) {
        return;
      }
      const restrictionType = fileRestrictionTypes[targetSourceType.fileRestrictionType];
      if (restrictionType === void 0) {
        return;
      }
      const whiteLists = new Set(
        targetSourceType.fileExtensionWhitelist.flatMap((fileType) => fileExtensionWhitelists[fileType]?.extensions).filter((type) => type !== void 0)
      );
      return {
        whiteLists,
        ...restrictionType
      };
    },
    [normalizedData]
  );
  return { ...rest, normalizedData, getRestrictionInfo, rawData: data };
};
const normalizeResponse = (data) => {
  const {
    fileExtensionWhitelists,
    fileRestrictionTypes,
    fileSourceTypeRestrictions
  } = data;
  const normalizedFileExtensionWhitelists = parseArrayToMapByKey(
    fileExtensionWhitelists,
    "fileExtensionWhitelist"
  );
  const normalizedFileRestrictionTypes = parseArrayToMapByKey(
    fileRestrictionTypes,
    "fileRestrictionType"
  );
  const normalizedFileSourceTypeRestrictions = parseArrayToMapByKey(
    fileSourceTypeRestrictions,
    "sourceType"
  );
  return {
    fileExtensionWhitelists: normalizedFileExtensionWhitelists,
    fileRestrictionTypes: normalizedFileRestrictionTypes,
    fileSourceTypeRestrictions: normalizedFileSourceTypeRestrictions
  };
};
function parseArrayToMapByKey(arr, key) {
  return Object.fromEntries(arr.map((v) => [v[key], v]));
}

export { useGetFileSourceTypeRestrictions };
//# sourceMappingURL=useFileSourceTypeRestrictions.mjs.map
